export default __webpack_public_path__ + "src/images/content/presentation-2-7038e88e4333f96590a11468670990cc.png";